module.exports = __webpack_public_path__ + "static/media/img_qudao5@2x.f0ff40e4.png";